import Axios from "../utils/axiosInstance";
import fileSaver from "file-saver";


export const postDispatch = (payload) => {
  console.log("payload :-", payload);
  let token = sessionStorage.getItem("token");
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.post(`/dispatch/adddispatchdetails?fkUserId=${fkUserId}&role=${role}`, payload, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: "arraybuffer",
  });
  // .then((response) => {
  //   var blob = new Blob([response.data], { type: "application/pdf" });
  //   fileSaver.saveAs(blob, `DispatchReport.pdf`);
  // });
};



// export const postDispatch = (payload) => {
//   console.log("payload:", payload);
//   const token = sessionStorage.getItem("token");

//   return Axios.post(`adddispatchdetails`, payload, {
//     headers: {
//       Authorization: `Bearer ${token}`,
  
//     },
//   }).then(response => {
//     console.log('Success status of dispatch in services:', response.status);
//     console.log('Success data check in services:', response.data);
//     return response;
//   }).catch(error => {
//     console.error('Error posting data:', error);
//     console.error("Request configuration: ", error.config); // Log the request config
//     if (error.response) {
//       // The request was made and the server responded with a status code
//       // that falls out of the range of 2xx
//       console.log("Error data :", error.response.data);
//       console.log("Error status:", error.response.status);
//       console.log("Error headers:", error.response.headers);
//     } else if (error.request) {
//       // The request was made but no response was received
//       console.log("Error request:", error.request);
//     } else {
//       // Something happened in setting up the request that triggered an Error
//       console.log("Error message:", error.message);
//     }

//     throw error; // Re-throw the error for further handling if necessary
//   });
// };


// API for getting list of dispatch
export const getDispatchList = (pageNo, fkUserId, role, headers) => {
  return Axios.get(`/dispatch/getdispatchdispenserlist/${pageNo}?fkUserId=${fkUserId}&role=${role}`, {
      headers,
    }
  );
};

// export const getDispatchEntryByDate = (pageNo, fromDate, toDate) => {
//   let token = sessionStorage.getItem("token");
//   let fkUserId = sessionStorage.getItem("pkUserId");
//   let role = sessionStorage.getItem("role");
//   return Axios.get(
//     `getDispatchReportBetweenTwoDate/${pageNo}?fromDate=${fromDate}&toDate=${toDate}&fkUserId=${fkUserId}&role=${role}`,
//     {
//       headers: { Authorization: `Bearer ${token}` },
//     }
//   );
// };

// API for getting sr no of dispatch order
export const getDispatchOrderNo = (customerName) => {
  let token = sessionStorage.getItem("token");
  return Axios.get(`/dispatch/getDispatchOrderNo?customerName=${customerName}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getDispatchPdfDownload = (fromDate, toDate) => {
  let fkUserId = sessionStorage.getItem("pkUserId");
  let role = sessionStorage.getItem("role");
  let fileType = ["Pdf"];
  let token = sessionStorage.getItem("token");
  return Axios.get(
    `/dispatch/getDispatchReportPDF?fileType=${fileType}&fromDate=${fromDate}&toDate=${toDate}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], { type: "application/pdf" });
    fileSaver.saveAs(blob, `customerDispatchreport.pdf`);
  });
};

export const getDispatchExcelDownload = (fromDate, toDate) => {
  let fkUserId = sessionStorage.getItem("pkUserId");
  let role = sessionStorage.getItem("role");
  let fileType = ["Excel"];
  let token = sessionStorage.getItem("token");
  return Axios.get(
    `/dispatch/getDispatchReportPDF?fileType=${fileType}&fromDate=${fromDate}&toDate=${toDate}&role=${role}&fkUserId=${fkUserId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((result) => {
    let blob = new Blob([result.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    fileSaver.saveAs(blob, "dispatchreportexcelbetweentwodate.xlsx");
  });
};



export const getDispatchAllPdfDownload = () => {
  let fkUserId = sessionStorage.getItem("pkUserId");
  let role = sessionStorage.getItem("role");
  let fileType = ["Pdf"];
  let token = sessionStorage.getItem("token");
  return Axios.get(
    `/dispatch/getDispatchDetailsListExcel?fileType=${fileType}&role=${role}&fkUserId=${fkUserId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], {
      type: "application/pdf",
    });
    fileSaver.saveAs(blob, `dispatchList.pdf`);
  });

};export const getDispatchAllExcelDownload = () => {
  let fkUserId = sessionStorage.getItem("pkUserId");
  let role = sessionStorage.getItem("role");
  let fileType = ["Excel"];
  let token = sessionStorage.getItem("token");
  return Axios.get(
    `/dispatch/getDispatchDetailsListExcel?fileType=${fileType}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    fileSaver.saveAs(blob, `dispatchList.xlsx`);
  });
};

// API for getting list of all dispatch by from and to date
export const getDispatchEntryByDate = (pageNo, fromDate, toDate) => {
  let fkUserId = sessionStorage.getItem("pkUserId");
  let role = sessionStorage.getItem("role");
  let token = sessionStorage.getItem("token");
  return Axios.get(
    `/dispatch/getDispatchReportBetweenTwoDate/${pageNo}?fromDate=${fromDate}&toDate=${toDate}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

// API for updating Dispatch details
export const putDispatch = (payload) => {
  let token = sessionStorage.getItem("token");
  return Axios.put(`upadtedispatchdispenser`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// API for getting Work Order No Wise Dispenser
export const getWorkOrderNoWiseDispenser = (workOrderNo) => {
  let token = sessionStorage.getItem("token");
  return Axios.get(
    `/production/getDispenserDetailsByWorkOrderNo?workOrderNo=${workOrderNo}`, {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};



export const getdispatchdispensersereialNo = (pageNo, dispenserSrNo) => {
  const role = sessionStorage.getItem("role");
  const fkUserId = sessionStorage.getItem("pkUserId");
  const token = sessionStorage.getItem("token");

  console.log('Role:', role, 'FkUserId:', fkUserId, 'Dispenser Serial Number:', dispenserSrNo);

  const url = `/dispatch/getDispatchDetailsListByDispenser/${pageNo}?role=${role}&fkUserId=${fkUserId}&dispenserSrNo=${dispenserSrNo}`;
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`, 
 
    }
  };

  return Axios.get(url, config)
    .then(response => {
      console.log('Response Data:', response.data);
      return response.data;
    })
    .catch(error => {
      console.error('There was an error fetching the dispenser serial number:', error);
      if (error.response) {

        console.error('Response data:', error.response.data);
        console.error('Status:', error.response.status);
        console.error('Headers:', error.response.headers);
      } else if (error.request) {

        console.error('The request was made but no response was received', error.request);
      } else {

        console.error('Error', error.message);
      }
      console.error('Config:', error.config);
    });
};




export const updateDispatchWOStatus = (payload, headers) => {
  // let role = sessionStorage.getItem("role");
  // let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.post(`/dispatch/updateDispatchWOstatus`, payload, {
    headers,
  });
};

